import React from 'react'
import './style.css'
import {Container, Tabs, Tab} from 'react-bootstrap'
import Transaksi from './transaksi'
import { useHistory } from 'react-router'
import Navbar from 'components/category/navbar'


export default function Main() {
    const history = useHistory()
    const handleClick = () => {
        history.push('/ber_akun')
    }
    return (
        <>
        <Navbar />
        <Container className="transaksi-berberkah">
            <div className="title">
                <img onClick={handleClick} src="asset/dashboard/icons/arr-left.svg" alt="left" />
                <h5>Transaksi Saya</h5>
            </div>
            <div className="content-transaksi">
                <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
                    {
                        Data.map((data, i) => {
                            return (
                                <Tab key={i} eventKey={data.link} title={data.title}>
                                        {i === 0 ? <Transaksi /> :null}                
                                </Tab>
                            )
                        })
                    }
                </Tabs>
            </div>
        </Container>
        </>
    )
}

const Data = [
    {link:"bayar", title:"Belum Dibayar"},{link:"proses", title:"Diproses"},{link:"kirim", title:"Dikirim"},{link:"selesai", title:"Selesai"},{link:"batal", title:"Dibatalkan"},{link:"kembali", title:"Pengembalian"}
]
